export default __webpack_public_path__ + "static/pencil-a9b20ad2162a9937fa9e7b845a080b45.mp4";